import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import AgGridWrapper from "../../../Reports/AgGridWrapper";
import { cellRenderer, filterParams } from "../../../Reports/utils/ReportUtils";

function AgridRentals({ data, hotelType, selectedLanguage }) {
  // getting the hotel id from the params
  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");
  const hotelCurrency = data.accessControl.hotel.hotel_currency;

  // column definitions
  const [columns, setColumns] = useState([
    {
      field: "bookingId",
      headerName: `${"Booking Id"}`,
      //   cellRendererFramework: (params) => cellRenderer(params, hotelId),
      checkboxSelection: true,
      headerCheckboxSelection: true,
      printWidth: "5%",
      dataType: "varchar",
    },
    { field: "guestName", headerName: "Guest Name", dataType: "varchar" },
    { field: "spaceName", headerName: "Space Name", dataType: "varchar" },
    {
      field: "bookingMadeDate",
      headerName: "Booking Made Date",
      filterParams: filterParams,
      dataType: "date",
      dateFormat: "MMM DD, YYYY",
    },
    {
      field: "bookingDate",
      headerName: "Booking Date",
      filterParams: filterParams,
      dataType: "date",
      dateFormat: "MMM DD, YYYY",
    },
    {
      field: "checkoutDate",
      headerName: "Checkout Date",
      filterParams: filterParams,
      dataType: "date",
      dateFormat: "MMM DD, YYYY",
    },
    { field: "inTime", headerName: "In Time", dataType: "time" },
    { field: "outTime", headerName: "Out Time", dataType: "time" },
    { field: "adults", headerName: "Adults", dataType: "number" },
    { field: "children", headerName: "Children", dataType: "number" },
    {
      field: "amount",
      headerName: `Amount (${hotelCurrency})`,
      valueFormatter: (params) => {
        return Number(params?.value?.toFixed(2));
      },
      printWidth: "5%",
      dataType: "float",
      filter: "agNumberColumnFilter",
    },
    {
      field: "tax",
      headerName: `Tax (${hotelCurrency})`,
      valueFormatter: (params) => {
        return Number(params?.value?.toFixed(2));
      },
      printWidth: "5%",
      dataType: "float",
      filter: "agNumberColumnFilter",
    },
    {
      field: "total",
      headerName: `Total (${hotelCurrency})`,
      valueFormatter: (params) => {
        return Number(params?.value?.toFixed(2));
      },
      printWidth: "5%",
      dataType: "float",
      filter: "agNumberColumnFilter",
    },
    { field: "passes", headerName: "Passes", dataType: "number" },
    { field: "packageName", headerName: "Package Name", dataType: "varchar" },
    { field: "source", headerName: "Source", dataType: "varchar" },
    { field: "status", headerName: "Status", dataType: "varchar" },
  ]);

  // Getting the pinned data
  // Setting the pinned row
  const [pinnedRow, setPinnedRow] = useState(null);
  function createPinnedData(params, rowsData) {
    let result = {
      bookingId: "Total",
      amount: 0,
      tax: 0,
      total: 0,
    };

    function updateVals(i) {
      result.amount += i.amount;
      result.tax += i.tax;
      result.total += i.total;
    }

    params.api.getSelectedRows().length === 0
      ? params.api.forEachNodeAfterFilter((row) => updateVals(row.data))
      : params.api.getSelectedRows().map((row) => updateVals(row));

    setPinnedRow([result]);
    params.api.setPinnedBottomRowData([result]);
  }

  return (
    <AgGridWrapper
      reportName={"Space Report"}
      columns={columns}
      reportActualType={"spaceReport"}
      createPinnedData={createPinnedData}
      pinnedRow={pinnedRow}
      hideIcon={false}
      selectedLanguage={selectedLanguage}
    />
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel, hotelType: state.auth.hotelType };
}
export default connect(mapStateToProps)(AgridRentals);
